import Button from 'src/components/Button/Button';
import { useWeb3Modal } from '@web3modal/wagmi/react';
import { useAccount } from 'wagmi';
import { useEffect } from 'react';

export const BscConnectView = ({ setAddress }) => {
    const { open } = useWeb3Modal();
    const { address } = useAccount();

    useEffect(() => {
        if (address) {
            setAddress(address);
        } else {
            open();
        }
    }, [address, setAddress, open]);

    return <Button onClick={open}>Connect wallet</Button>;
};
